/**
 * ==========================================================================
 * JHC Commerce Framework
 * FAQ
 * --------------------------------------------------------------------------
 * - Accordion open/close (single or multi-open, see ALLOW_MULTIPLE below)
 * - Scroll reveal for header, categories, and items (scoped to .jhc-faq)
 * ==========================================================================
 */

(function () {
  'use strict';

  // Set to true if you want more than one answer open at a time.
  var ALLOW_MULTIPLE = true;

  function initAccordion(root) {
    if (!root) return;

    var triggers = root.querySelectorAll('.jhc-faq__trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));

        if (!ALLOW_MULTIPLE && !expanded) {
          triggers.forEach(function (otherTrigger) {
            if (otherTrigger === trigger) return;
            var otherPanel = document.getElementById(otherTrigger.getAttribute('aria-controls'));
            otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.classList.remove('is-open');
          });
        }

        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.classList.toggle('is-open', !expanded);
      });
    });
  }

  function initReveal(root) {
    if (!root) return;

    var revealEls = root.querySelectorAll('.jhc-faq__reveal');
    if (!revealEls.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init(root) {
    initAccordion(root);
    initReveal(root);
  }

  document.querySelectorAll('.jhc-faq').forEach(init);

  // Re-init when the section is added/updated in the Theme Editor
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('.jhc-faq'));
  });
})();